class Store {
  constructor() {
    this.persistStore = false;
    this.form = {
      items: [],
      address: null,
      account_id: null,
      customer_to_collect: true,
      remarks: null,
      customer_reference: null,
      contact_number: null,
      notification_contact_number: null,
      isCustomer: false,
    }

    this.itemQtyCount = {}
    this.warningMessage = null
  }

  resetForm() {
    this.form.items = [];
    this.form.account_id = null;
  }

  persist(setState = true) {
    this.persistStore = setState

    if(localStorage.getItem('store')) {
      this.form = Object.assign({}, JSON.parse(localStorage.getItem('store')))
      console.log('form', this.form)
    }
  }

  syncToLocalStorage() {
    if(this.persistStore) {
      localStorage.setItem('store', JSON.stringify(this.form))
    }
  }

  qtyForItemUnit(id, unit) {
    let item = this.form.items.find(itm  => itm.product.id === id && itm.unit === unit)
    if (item) {
      return item.qty;
    }
    return 0;
  }

  setCustomerMode() {
    this.form.isCustomer = true
  }

  // form() {
  //   return this.form
  // }

  updateQty(item) {

    if (item.qty === 0) {
      this.removeItem(item)
      this.updateTotalFor(item)

    } else {
      if (this.form.isCustomer) {

        let qtyUsed = this.itemQtyCount[item.product.id] ? this.itemQtyCount[item.product.id] : 0
        let availableInUnits = item.product.units[item.unit].available

        let unitToBaseRate = item.product.units[item.unit].unit_rate

        // let qtyInBase = item.qty * unitToBaseRate
        let availableInBaseUnit = availableInUnits * unitToBaseRate

        let loadedQuantity = this.qtyForItemUnit(item.product.id, item.unit)
        let loadedQuantityInBase = loadedQuantity * unitToBaseRate

        let diff = item.qty - loadedQuantity
        let diffInBase = diff * unitToBaseRate


        // check quantity with inventory available
        if (item.product.min_order_quantity && (qtyUsed + diffInBase) < item.product.min_order_quantity) {
          // if quantity used + diff is less than min order quantity

          // items to add = min order quantity - quantity used - loaded quantity
          let itemsToAdd = item.product.min_order_quantity - (qtyUsed - loadedQuantityInBase)

          if (itemsToAdd >= 0) {
            item.qty = Math.ceil((itemsToAdd / unitToBaseRate).toFixed(2));
          }
        } else if (item.product.max_order_quantity && (qtyUsed + diffInBase) > item.product.max_order_quantity) {
          let itemsToAdd = item.product.max_order_quantity - (qtyUsed - loadedQuantityInBase)

          if (itemsToAdd > 0) {
            item.qty = Math.ceil((itemsToAdd / unitToBaseRate).toFixed(2));
          }
        }

        let nextQTY = diffInBase + qtyUsed
        if(nextQTY <= availableInBaseUnit) {
          this.commit(item)
        }

      } else {
        this.commit(item)
      }

      this.updateTotalFor(item)
    }
  }

  commit(item) {
    let row = this.form.items.find(itm => itm.product.item_code === item.product.item_code && itm.unit === item.unit)

    if (row) {
      row.qty = item.qty
    } else {

      row = {...item, qty: item.qty}

      this.form.items.push(row)
    }

    this.syncToLocalStorage();
  }

  removeItem(item) {
    let row = this.form.items.find(itm => itm.product.item_code === item.product.item_code && itm.unit === item.unit)

    if (row) {
      let index = this.form.items.indexOf(row)
      this.form.items.splice(index, 1)
      this.syncToLocalStorage();
    }
  }

  updateTotalFor(item) {
    let items = this.form.items.filter(itm => itm.product.id === item.product.id)

    let qty = 0;

    items.forEach(itm => {
      let unitToBase = itm.product.units[itm.unit].unit_rate

      qty = qty + parseFloat((itm.qty * unitToBase).toFixed(2))
    })

    this.itemQtyCount[item.product.id] = qty

  }

}
const store = new Store()
export default store
